module.exports = __webpack_public_path__ + "static/img/top_logo.ec4fb50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top_logo.png
// module id = F8cZ
// module chunks = 1